import $ from "jquery";
import CONFIG from "@bd-core/config";
import compile from "@bd-utils/handlerbars-helper";
import { getDocuments } from "@bd-stores/game-progress";
import Swiper from "swiper";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

export default class Toolbox {
    constructor() {
        this.elms = {
            documentItem: ".toolbox-popup .swiper-slide",
            documentThumbItem: ".toolbox-popup-thumb-item",
            documentControlPrev: ".toolbox-popup-prev",
            documentControlNext: ".toolbox-popup-next",
            documentControlTitle: ".toolbox-popup-control-title",
            documentControlRemove: ".toolbox-popup-control-remove",
            documentControlFullscreen: ".toolbox-popup-control-fullscreen",
            popupFullscreen: ".toolbox-fullscreen-popup",
        };

        this.toolboxPopupSlider = null;
        this.syncSliderControls = null;
        this.calculateNotificationTotal = null;
    }

    render() {
        if (!CONFIG.game.cfgLimit) return false;
        const self = this;
        const elms = this.elms;

        const isToolboxExist = $(".js-toolbox").length > 0;
        if (!isToolboxExist) return false;

        // Init title for Slider Controls
        const initTitle = $(".toolbox-popup .swiper-slide")
            .first()
            .data("title");
        $(elms.documentControlTitle).html(initTitle);

        self.calculateNotificationTotal = () => {
            // const document = $("#notification-document").data("count");
            // const briefing = 0; //$('#notification-briefing').data('count');
            const total = 0; // parseInt(document) + parseInt(briefing);

            $("#notification-total").text("+" + total.toString());
            $("#notification-total").data("count", total);
            if (total) {
                $("#notification-badge-total").show();
            } else {
                $("#notification-badge-total").hide();
            }
        };

        $(".toolbox-toggle").on("click", function () {
            const $toolbox = $(".toolbox");
            const isOpen = $toolbox.hasClass("is-open");

            if (isOpen) {
                $toolbox.removeClass("is-open");
            } else {
                $toolbox.addClass("is-open");
                $(".js-timer").css("z-index", "9");
            }
        });

        $(".toolbox-button.toolbox-open-document").on("click", function () {
            $(".toolbox").removeClass("is-open");
            $(".toolbox-popup").addClass("is-open");

            $("#notification-document").text("0");
            $("#notification-document").data("count", 0);
            $("#notification-badge-document").hide();
            self.calculateNotificationTotal();
        });

        $(".toolbox-button.toolbox-open-briefing").on("click", function () {
            $(".toolbox").removeClass("is-open");
            $(".toolbox-briefing").addClass("is-open");

            $(".briefing.popup").addClass("is-open");

            $("#notification-briefing").text("0");
            $("#notification-briefing").data("count", 0);
            $("#notification-badge-briefing").hide();
            self.calculateNotificationTotal();
        });

        $(".toolbox-button.toolbox-open-phone").on("click", function () {
            $(".toolbox").removeClass("is-open");
            $(".toolbox-phone").addClass("is-open");
        });

        $(".toolbox-popup .popup-close").on("click", function () {
            $(".toolbox-popup").removeClass("is-open");
        });

        $(".toolbox-popup-control-fullscreen").on("click", function () {
            const $fullscreen = $(".js-toolbox-fullscreen");
            const $activeDoc = $(`${elms.documentItem}.swiper-slide-active`);
            const type = $activeDoc.attr("data-type");
            
            if(type === "image") {
                const imgTitle = $activeDoc.attr("data-title");
                const imgUrl = $activeDoc.attr("doc_url");
                const $theImg = $fullscreen.find("img");
                $theImg.attr("src", imgUrl).attr("alt", imgTitle);
                $fullscreen.find("p").hide();
            } else {
                const textTitle = $activeDoc.attr("data-title");
                const text = $activeDoc.find("p").text();
                const $theText = $fullscreen.find("p");
                $theText.html(text).attr("data-title", textTitle);
                $fullscreen.find("img").hide();
            }
            
            $fullscreen.addClass("is-open");
        });

        $(".toolbox-fullscreen-popup .popup-close").on("click", function () {
            $(".toolbox-fullscreen-popup").removeClass("is-open");
        });

        const documents = getDocuments();

        if (Object.keys(documents).length > 0) {
            const templateSwiper = $("#toolbox-swiper").html();

            $(".js-toolbox-swiper").each(function () {
                const html = compile(templateSwiper, { documents: documents });
                $(this).html(html);
            });
        }

        self.toolboxPopupSlider = new Swiper(".swiper", {
            init: false,
            // loop: true,
            rewind: true,
            touchRatio: 0,
            effect: "fade",
            fadeEffect: {
                crossFade: true,
            },
            modules: [Navigation],
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
        });

        self.syncSliderControls = () => {
            const hasActiveIndex =
                self.toolboxPopupSlider && self.toolboxPopupSlider.activeIndex
                    ? true
                    : false;

            const currentIndex = hasActiveIndex
                ? // @ts-ignore
                  parseInt(self.toolboxPopupSlider.activeIndex)
                : 0;
            const currentSlideDOM =
                self.toolboxPopupSlider.slides[currentIndex];

            const slidesLength = parseInt(
                // @ts-ignore
                self.toolboxPopupSlider.slides.length,
            );

            const slideTitle = $(currentSlideDOM).data("title");
            const disabledRemove = slidesLength === 0;
            const disabledNext =
                currentIndex === slidesLength - 1 || slidesLength < 1
                    ? true
                    : false;
            const disabledPrev = currentIndex === 0 ? true : false;

            $(elms.documentThumbItem.concat(".is-active")).removeClass(
                "is-active",
            );
            $(elms.documentThumbItem).eq(currentIndex).addClass("is-active");
            $(elms.documentControlRemove).prop("disabled", disabledRemove);
            $(elms.documentControlFullscreen).prop("disabled", disabledRemove);
            $(elms.documentControlNext).prop("disabled", disabledNext);
            $(elms.documentControlPrev).prop("disabled", disabledPrev);
            $(elms.documentControlTitle).html(slideTitle);
        };

        self.toolboxPopupSlider.on("init", self.syncSliderControls);
        self.toolboxPopupSlider.on("slideChange", self.syncSliderControls);
        self.toolboxPopupSlider.init();

        $(elms.documentControlPrev).on("click", function () {
            self.toolboxPopupSlider.slidePrev();
        });

        $(elms.documentControlNext).on("click", function () {
            self.toolboxPopupSlider.slideNext();
        });
    }
}
